import { dataProjects } from "../../data";

const Portfolio = () => {
  return (
    <div className="portfolio my-5">
      <div className="container">
        <div className="row justify-content-around align-items-center">
          {dataProjects.map((item) => (
            <div key={item.id} className="my-3 my-lg-4 g-3 g-lg-5 col-9 col-sm-6 col-lg-4 col-xxl-3">
              <a href={item.url} target="_black" className="text-decoration-none">
                <div className="card shadow text-center">
                  <item.Img />
                  <div className="card-body">
                    <h4 className="card-title text-secondary lead fw-bold">{item.description}</h4>
                    {/* <small className="lead d-none d-sm-block">Description</small> */}
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
